import { isNotNil } from "@etudescarre/utils";
import { todayLocal } from "@/lib/utils/date";

export const REMISE_NOT_RECORDED =
  "La remise n'est pas enregistrée : le serveur n'a pas répondu. Réessayez.";

/** A document of a send, with the formats that send carries. */
export type SentDocument = {
  fullname: string | null;
  native: boolean;
  pdf: boolean;
  paperCopies: number | null;
};

/** Formats of the send, not the files the documents have. */
export function sentFormatsLabel(documents: SentDocument[]): string {
  const formats: string[] = [];
  if (documents.some((d) => d.native)) formats.push("Natif");
  if (documents.some((d) => d.pdf)) formats.push("PDF");
  if (documents.some((d) => isNotNil(d.paperCopies))) formats.push("Papier");
  return formats.join(" / ");
}

/** `max` stops the calendar, not a date typed on the keyboard. */
export function remiseDateError(deliveredOn: string): string | null {
  if (deliveredOn === "") return "Indiquez la date de remise.";
  return deliveredOn > todayLocal()
    ? "La date de remise ne peut pas être future."
    : null;
}

export type RemiseButtonLabelProps = {
  label: string;
  count: number;
};

/**
 * A hidden copy keeps room for the count: it appears on the first ticked row,
 * and the button must not grow and push the controls beside it.
 */
export function RemiseButtonLabel({ label, count }: RemiseButtonLabelProps) {
  return (
    <span className="inline-grid justify-items-center">
      <span aria-hidden className="invisible col-start-1 row-start-1">
        {`${label} (99)`}
      </span>
      <span className="col-start-1 row-start-1">
        {count > 0 ? `${label} (${count})` : label}
      </span>
    </span>
  );
}

export type RemiseDateFieldProps = {
  value: string;
  onChange: (value: string) => void;
  error: string | null;
};

/**
 * "Date de remise" of the two hand-delivery screens. The message sits in the
 * bottom padding of the header, so it does not push the table down.
 */
export function RemiseDateField({
  value,
  onChange,
  error,
}: RemiseDateFieldProps) {
  return (
    <div className="relative">
      <label className="flex flex-col text-xs font-medium text-zinc-600 dark:text-zinc-400">
        Date de remise
        <input
          type="date"
          value={value}
          max={todayLocal()}
          aria-invalid={isNotNil(error)}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1 rounded-md border border-zinc-300 px-2 py-1 text-sm text-zinc-900 aria-invalid:border-red-500 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-100"
        />
      </label>
      {isNotNil(error) && (
        <p
          role="alert"
          className="absolute right-0 top-full whitespace-nowrap text-xs text-red-600 dark:text-red-400"
        >
          {error}
        </p>
      )}
    </div>
  );
}
